
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/generated/ui/shared/outcomes/content-view/jst/noOutcomesWarning';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, stack2, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class=\"no-outcomes-warning\">\n  <div class=\"alert\" role=\"alert\">\n    ";
  stack1 = (helper = helpers.__i18nliner_escape || (depth0 && depth0.__i18nliner_escape),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.noOutcomesLinkLabel), options) : helperMissing.call(depth0, "__i18nliner_escape", (depth0 && depth0.noOutcomesLinkLabel), options));
  stack2 = (helper = helpers.__i18nliner_escape || (depth0 && depth0.__i18nliner_escape),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.addOutcomesUrl), options) : helperMissing.call(depth0, "__i18nliner_escape", (depth0 && depth0.addOutcomesUrl), options));
  stack1 = (helper = helpers.__i18nliner_concat || (depth0 && depth0.__i18nliner_concat),options={hash:{},data:data},helper ? helper.call(depth0, "<a href=\"", stack2, "\" aria-label=\"", stack1, "\">$1</a>", options) : helperMissing.call(depth0, "__i18nliner_concat", "<a href=\"", stack2, "\" aria-label=\"", stack1, "\">$1</a>", options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': (stack1),
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.no_outcomes_warning")
  },data:data},helper ? helper.call(depth0, "you_have_no_outcomes_click_here_to_create_one_ebf262a3", "You have no outcomes. *Click here* to create one.", options) : helperMissing.call(depth0, "t", "you_have_no_outcomes_click_here_to_create_one_ebf262a3", "You have no outcomes. *Click here* to create one.", options)))
    + "\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  